
import { Injectable } from '@angular/core';
import { InAppBrowser, InAppBrowserOptions } from '@awesome-cordova-plugins/in-app-browser';
import { logger } from 'src/app/common/services/logging/logging.service';
import { AsyncSubject } from 'rxjs';
import { TranslateUtilityService } from './translation-utility.service';
import { PlatformService } from './platform.service';

@Injectable({
    providedIn: 'root'
})
export class InAppBrowserService {

    constructor(private translate: TranslateUtilityService) { }

    public openInternalBrowser(url: string, callbackUrl: string): AsyncSubject<boolean> {
        let ret = new AsyncSubject<boolean>();

        let options: InAppBrowserOptions = {
            location: "no",
            clearcache: "no",
            clearsessioncache: "no",
            zoom: "no",
            hardwareback: "no",
            toolbar: "yes", // For iOS
            footer: "yes", // For Android
            closebuttoncaption: this.translate.instant("BACK")
        }

        const browserRef = InAppBrowser.create(url, "_blank", options);
        browserRef.on("loadstart").subscribe((event) => {
            logger.debug("Load Start Event: ", event);
            if (event.url.indexOf(callbackUrl) != -1) {
                browserRef.close();
                ret.next(true);
            }
        });
        browserRef.on("loaderror").subscribe((event) => {
            logger.error("Load Error Event: ", event);
            ret.next(false);
            browserRef.close();
        });
        browserRef.on("exit").subscribe((event) => {
            logger.debug("Exit Event: ", event);
            ret.complete();
        });

        return ret;
    }

    /**
     * Open System Browser
     */
    public openExternalBrowser(url: string): void {
        if (PlatformService.isBrowser()) {
            window.open(url, '_blank');
        }
        else {
            InAppBrowser.create(url, "_system");
        }
    }

}